/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.wizards.init());


App.wizards = {
  init() {
    return $(document)
      .off("click", ".js-wizard-button", App.wizards.button_clicked)
      .on("click", ".js-wizard-button", App.wizards.button_clicked);
  },


  button_clicked(evt) {
    $(".js-wizard-step").removeClass("is-active");
    const next_step = $(evt.target).attr("data-next-step");
    return $(`.js-wizard-step[data-step=${next_step}]`).addClass("is-active");
  }
};
